import axios from 'axios';
import { z } from 'zod';

// ******************************************************** //
// **************** ERROR RESPONSE OBJECTS **************** //
// ******************************************************** //

export const zApiSimpleError = z.object({
  error: z.string(),
});

export const zApiStandardException = z.object({
  message: z.string(),
  statusCode: z.number(),
})

// ******************************************************** //
//                   ERROR RESPONSE TYPES                   //
// ******************************************************** //

type ApiSimpleError = z.infer<typeof zApiSimpleError>;

type ApiStandardException = z.infer<typeof zApiStandardException>;

// ******************************************************** //
//               ERROR TYPE CHECKER FUNCTIONS               //
// ******************************************************** //

export const isApiSimpleError = (input: unknown): input is ApiSimpleError =>
  zApiSimpleError.safeParse(input).success;

export const isApiStandardException = (input: unknown): input is ApiStandardException =>
  zApiStandardException.safeParse(input).success;

// ******************************************************** //
//                   ERROR HANDLER FUNCTIONS                //
// ******************************************************** //

export const getErrorMessage = (
  error: unknown,
  handleUnknownError = (_e: unknown) => {
    // Do anything
  },
) => {
  if (axios.isAxiosError(error)) {
    const errorData = error.response?.data;

    if (isApiStandardException(errorData)) {
      return errorData.message;
    }

    if (isApiSimpleError(errorData)) {
      return errorData.error;
    }
  }

  handleUnknownError(error); // Allow to pass a "last chance" callback, like Sentry.captureException

  // Return error as string if all checks failed
  return String(error);
};

export const getStandardErrorData = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const errorData = error.response?.data;

    if (isApiStandardException(errorData)) {
      return errorData;
    }

    return null;
  }
  return null;
};